module.exports = __webpack_public_path__ + "img/fob-cover.57502d32.png";